export default "__VITE_ASSET__DKyeoghY__"